import { get, set } from '~libs/localstorage';
import { addRtkQueryBridges, buildSlice, CommonState, Row } from '~libs/reduxUtils';

import { conflictsApi, typePrefix } from '~weekly-planner/actions/appointments/conflicts';

const initialState: CommonState<Row> & {
  params: { [key: string]: any };
  options: { [key: string]: boolean };
  count?: number;
} = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],

  params: { limit: 30 },
  options: {
    conflictTime: true,
    conflictTravel: true,
    conflictPreference: true,
    ...get('weekly-planner-conflict-view-options'),
  },
};

const slice = buildSlice(typePrefix, initialState, {
  extraReducers: (builder) => {
    addRtkQueryBridges<CommonState<Row>, Row>(builder, [
      {
        endpoint: conflictsApi.endpoints.getConflicts,
        mode: 'list',
        apply: (state, payload: any) => {
          state.loading = 'fulfilled';
          const normalized = Array.isArray(payload)
            ? { rows: payload, total: payload.length }
            : (payload ?? { rows: [], total: 0 });
          state.rows = normalized.rows ?? [];
          state.count = normalized.total ?? 0;
          state.hasLoaded = true;
        },
        onPending: (state) => {
          state.loading = 'pending';
        },
        onRejected: (state) => {
          state.loading = 'error';
        },
      },
    ]);
  },
  customActions: {
    toggleOption(state, action) {
      const { key, toggle } = action.payload;
      state.options[key] = toggle;
      set('weekly-planner-conflict-view-options', state.options);
    },
  },
});

export const { clear, updateParams, toggleOption } = slice.actions;
export default slice.reducer;
